import { DatePipe } from "@angular/common"
import { NgModule } from "@angular/core"
import { TrDatePipe } from "./tr-date.pipe"

@NgModule({
  exports: [
    TrDatePipe,
  ],
  declarations: [
    TrDatePipe,
  ],
  providers: [
    DatePipe,
  ]
})
export class TrDateModule {}
